import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { SHA256 } from "crypto-js";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomInput from "../../components/CustomInput.js";
import { REACT_FUNCTION_KEY_SCREEN, REACT_TERMINAL_PAGE } from "../../constants/ReactEndPoints";
import { checkForEmployeeLogin } from "../../services/FunctionKeysService.js";
import OnboardLayout from "../../components/layout-components/OnboardLayout";
import CommonUtil from "../../util/CommonUtils.js";
import { removeLoggedInData } from "../../util/helperFunction.js";
import { useTranslation } from "react-i18next";
import { resetDefaultLanguage } from "../../i18n/languageService.js";

export default function EmployeeLogin() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [payload, setPayload] = useState({
        employeeNumber: "",
        password: "",
        uuid: localStorage.getItem("uuid") ? localStorage.getItem("uuid") : "",
        companyCode: localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "",
    });

    const [error, setError] = useState({
        employeeNumber: "",
        password: "",
    })

    const terminalName = localStorage.getItem('terminal')
    const deviceName = localStorage.getItem('deviceName')
    const locationName = localStorage.getItem('location')
    
    useEffect(() => {
        
        resetDefaultLanguage();

        removeLoggedInData();
        if ((CommonUtil.isEmptyString(localStorage.getItem('accountType')) || localStorage.getItem('accountType') === "Kiosk") && (CommonUtil.isEmptyString(localStorage.getItem('terminal')) || CommonUtil.isEmptyString(localStorage.getItem('uuid')))) {
            navigate(REACT_TERMINAL_PAGE);
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPayload({
            ...payload,
            [name]: value,
        });
    };

    const handleSubmit = async () => {

        if (isValidToSubmit()) {
            let latestEncryptedPayload = {
                employeeNumber: payload.employeeNumber.toString(),
                password: SHA256(payload.password).toString(),
                uuid: payload.uuid,
                companyCode: payload.companyCode,
                accountType: localStorage.getItem('accountType'),
            }
            checkForEmployeeLogin(latestEncryptedPayload).then((res) => {

                const responseData = res?.data?.data?.[0];
                const isSuccess = res?.status === 200 && res?.data?.message?.toLowerCase() == "success";

                if (isSuccess && !CommonUtil.isEmpty(responseData)) {
                    const { deviceName, location, terminal, uuid, employeeNumber, employeeName, deviceSn } = responseData

                    const accType = localStorage.getItem('accountType')?.toLowerCase() !== "mytime";

                    if (!CommonUtil.isEmptyString(deviceSn)) {
                        localStorage.setItem('virtualDeviceId', deviceSn)
                    }

                    localStorage.setItem("deviceName", accType ? deviceName.toUpperCase() : 'ZKTKDevice - MyTime'?.toUpperCase());
                    localStorage.setItem("location", location?.toUpperCase() || "");
                    localStorage.setItem("terminal", terminal || "");
                    localStorage.setItem("uuid", uuid || "");
                    localStorage.setItem('employeeNumber', employeeNumber || "")
                    localStorage.setItem('isLoggedIn', true)
                    localStorage.setItem('employeeName', employeeName || "")
                    navigate(REACT_FUNCTION_KEY_SCREEN, { state: { 'employeeNumber': employeeNumber } });
                } else {
                    enqueueSnackbar(res?.data?.message, {
                        variant: 'error',
                    });
                }
            }).catch((error) => {
                console.error("Error while login the employee >>>>", error);
            })
        }
    }

    const isValidToSubmit = () => {
        if (payload.employeeNumber.trim().length === 0) {
            setError({
                ...error,
                employeeNumber:t("employeeLogin.errors.employeeNumberRequired"),
            });
            return false;
        }

        if (payload.password.trim().length === 0) {
            setError({
                ...error,
                password:t("employeeLogin.errors.passwordRequired"),
            });
            return false;
        }

        return true;
    };


    return (
        <OnboardLayout>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
            >
                <Box
                    display={'flex'}
                    sx={{
                        marginBottom: { xs: '10px', sm: "15px", md: '10px', lg: '15px', xl: '20px' }
                    }}
                >
                    <Typography sx={{
                        paddingTop: '0px',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        fontSize: '12px',
                        fontWeight: 400,
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                        color: '#304669'
                    }}
                    >
                        {deviceName != undefined && deviceName != null ? deviceName : locationName != undefined && locationName != null ? locationName : terminalName}
                    </Typography>
                </Box>

                <CustomInput
                    label={t("employeeLogin.labels.employeeNumber")}
                    size="small"
                    name="employeeNumber"
                    placeholder={t("employeeLogin.placeholders.employeeNumber")}
                    value={payload.employeeNumber}
                    handleChange={handleChange}
                    required
                    error={error.employeeNumber}
                    helperText={error.employeeNumber}
                    type={'text'}
                    validation={'alpha-numeric'}
                    autoComplete="off"
                    autoFocus
                    sx={{
                        marginBottom: "10px"
                    }}
                />
                <CustomInput
                    label={t("employeeLogin.labels.password")}
                    size="small"
                    name="password"
                    placeholder={t("employeeLogin.placeholders.password")}
                    value={payload.password}
                    handleChange={handleChange}
                    type={'password'}
                    // validation="password"
                    error={error.password}
                    helperText={error.password}
                    required
                    autoComplete="off"
                />
                <Button
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2, backgroundColor: 'rgba(0, 164, 255, 1)' }}
                    onClick={handleSubmit}
                >
                    {t("employeeLogin.buttons.enter")}
                </Button>
            </Box>
        </OnboardLayout>
    );
}
